import { APIClient } from 'src/helper/api_helper';
import { useAccountQuoteDraft } from './updateQuote/useAccountQuoteDraft';
const api = new APIClient();
const transports = Object.fromEntries(['actuals', 'invoice'].map(kind => [kind, {
  getQuoteEditorDraft: async id => {
    const response = await api.get(`/documents/${kind}/${id}/editor-draft`, {});
    const result = response?.data?.data;
    if (result?.requestKey && result.working && result.working.requestKey !== result.requestKey) {
      // Keep this account's work while attaching the latest document-scoped review context.
      const snapshot = result.working.snapshot;
      const baseline = result.initial.reviewBaseline || result.canonical.positions;
      const requested = result.initial.reviewRequested || [];
      result.working.snapshot = { ...snapshot, reviewBaseline: baseline, reviewRequested: requested, reviewRequestKey: result.requestKey, reviewHeader: result.initial.reviewHeader,
        positions: [...snapshot.positions.map(row => ({ ...row, clientRequestDraftDecisions: [] })),
          ...requested.filter(row => !baseline.some(original => String(original.id) === String(row.id)) && !snapshot.positions.some(saved => String(saved.id) === String(row.id)))],
        worksheetMembership: undefined };
    }
    return response;
  },
  saveQuoteEditorDraft: (id, data) => api.update(`/documents/${kind}/${id}/editor-draft`, data),
  createQuoteEditorVersion: (id, data) => api.create(`/documents/${kind}/${id}/editor-draft/versions`, data, {}),
  getQuoteEditorVersion: async (id, key) => {
    const response = await api.get(`/documents/${kind}/${id}/editor-draft/versions/${encodeURIComponent(key)}`, {});
    // An explicitly selected historical version replaces the worksheet after the current buffer is preserved.
    // Only recovery of a working draft rebases against its original canonical document.
    if (response?.data?.data?.snapshot) {
      const snapshot = response.data.data.snapshot;
      snapshot.reviewRequestKey ??= snapshot.worksheetMembership?.requestKey || '';
      delete snapshot._base;
    }
    return response;
  }
}]));
export function useAccountDocumentDraft(kind: 'actuals' | 'invoice', options: Parameters<typeof useAccountQuoteDraft>[0]) {
  return useAccountQuoteDraft({ ...options, scopeKey: kind, transport: transports[kind], preserveCurrentOnRestore: true });
}
